export const SET_DATE = 'SET_DATE';
export const SET_TODAY_WORKLOGS = 'SET_TODAY_WORKLOGS';
export const SET_OPEN_CHOSEN_DATE_MODAL = 'SET_OPEN_CHOSEN_DATE_MODAL'
export const TOGGLE_REFETCH_FLAG = 'TOGGLE_REFETCH_FLAG'
